import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-app-master',
  templateUrl: './app-master.component.html',
  styleUrls: ['./app-master.component.css']
})
export class AppMasterComponent implements OnInit, AfterViewInit {
  isMobileView: boolean = true;
  constructor(private _router: Router) {
    this.isMobileView = false;
  }

  ngOnInit() {
    if (this.isMobileView)
      this._router.navigateByUrl('m');
    else
      this._router.navigateByUrl('w');
  }

  ngAfterViewInit() {

  }

}
